<template>
  <div
    class="product-block fact-block"
    :class="'theme__color--' + theme"
  >
    <div
      v-if="label || isEditable"
      class="tag-wrapper"
    >
      <div class="tags tags-sm theme__color--label">
        <span v-edit="'Label'">
          {{ label }}
        </span>
      </div>
      <svgicon
        name="Misc/LabelAngle24"
        class="angle-right"
      />
    </div>
    <section
      class="product-block__components"
    >
      <component
        :is="item.component === 'RecipeBlock' ? 'article-recipe-block' : item.component | kebab"
        v-for="(item) in listBlocks"
        :key="item.title"
        :recipe="item.recipe"
        :title="item.title"
        :content="item.content"
        :image="item.image"
        :button-label="item.buttonLabel"
        :url="item.url"
        :in-list="true"
      />
    </section>
  </div>
</template>

<script>
export default {
  name: "ProductBlock",
  props: {
    theme: {
      type: String,
      default: 'default'
    },
    listBlocks: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: null
    },
  }
}
</script>

<style lang="scss">
// Since product block is almost an copy of fact block we use .fact-block to inherit those styles
.product-block {
  & &__components > * {
    margin-left: 0;
    margin-right: 0;

    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
